<nav>
  <div class="navbar-wrapper">
    <app-nav-logo [instance]="instance" [userData]="userData" [navCollapsed]="navCollapsed" (onNavCollapse)="navCollapse()"></app-nav-logo>
    <app-nav-content (onNavCollapsedMob)="navCollapseMob()"></app-nav-content>
  </div>
</nav>
